import React, { Component, useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
//Material UI Styles
import { lighten, makeStyles, styled } from "@material-ui/core/styles";
import { Redirect } from "react-router";
import AddAction from "./addAction";
import Checbox from "./checkbox";
import Badge from "@material-ui/core/Badge";
import Popover from "@material-ui/core/Popover";
import { useHistory } from "react-router-dom";
import List from "@material-ui/core/List";
import GlobalApi from "./../../Global";
import Checkbox from "@material-ui/core/Checkbox";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import moment from "moment";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ErrorIcon from '@material-ui/icons/Error';
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import DarkButton from "./../../Global/DarkButton";
import Colors from "./../../Global/colors";
import NoRecords from "./../../Global/NoRecords";
import Spinner from "./../../Global/Spinner2";
import chat from "../../Assets/chat.png";
import add from "../../Assets/add.png";
import filter from "../../Assets/Filter_Icon.png";
import due_date from "../../Assets/due_date.png";
import search from "../../Assets/search.png";
import MiddleHeader from "../middleHeader/middleHeader";
import { useSelector, useDispatch, connect } from "react-redux";
import {useTranslation} from 'react-i18next';
import "./action.css";
import { io } from "socket.io-client";


const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));


const socket = io(GlobalApi.replace("api", ""));



function Action() {
  const { t } = useTranslation();
  const classes = useStyles();
  let language = useSelector((state) => state.languageReducer.language);
  let currentCompany = useSelector((state) => state.companyReducer.company);
  let userData = useSelector((state) => state.userReducer.user);
  const [modal, setModal] = useState(false);
  const [row, setRow] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filterApplied, setFilterApplied] = useState(false);
  const [actionLoader, setActionLoader] = useState(false);
  const [userFilter, setUserFilter] = useState("");
  const [assignedByFilter, setAssignedByFilter] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [permissions_obj, setPermissionObj] = useState({});
  const [selectedAssigners, setSelectedAssigners] = useState([]);
  const [filterMenu1, setFilterMenu1] = React.useState(null);
  const [filterMenu2, setFilterMenu2] = React.useState(null);
  const [filterMenu3, setFilterMenu3] = React.useState(null);
  const [filterMenu4, setFilterMenu4] = React.useState(null);
  const [filterMenu5, setFilterMenu5] = React.useState(null);
  const [filterMenu6, setFilterMenu6] = React.useState(null);
  const [packageDetails, setPackageDetails] = React.useState(null);
  const [selectedPriority, setSelectedPriority] = React.useState([]);
  const [selectedStatus, setSelectedStatus] = React.useState([]);
  const [Assignees, setAssignees] = useState([]);
  const [AssigneBy, setAssignedBy] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroups] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState({
    Assignees: false,
    Assigners: false,
    Sites: false,
    Templates: false,
  });
  const [datesFilters, setDateFilters] = React.useState({
    today: false,
    yesterday: false,
    last7: false,
    last15: false,
    lastMonth: false,
    startFlag: false,
    endFlag: false,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const history = useHistory();

  useEffect(
    () => {
      fetchActions(true);
      getPermissions();
      getUsers();
      getPackageDetails();
      getGroups();
    },
    [currentCompany]
  );

  useEffect(()=>{
    if(row  != null){
      socket.on('Chats_Notification', (notification) => {
        console.log('Actions Chat Notification >>>>>>>.', notification);
        // console.log('Actions Total >>>>>>>>', actions);
        let total_actions = [...row];
        // console.log('Total Actions >>>>>>',total_actions);
        let indx = total_actions.findIndex(x => x?.id === notification?.action_id);
        // console.log('Action Matched Index >>>>>>>>', indx);
        if (indx != -1) {
          // let matchedAction_users = total_actions[indx].Users;
          // let chat_notifications = notification?.chat_notification_status;
          let update_obj={};
          for (const iterator of notification?.chat_notification_status) {
             if(iterator?.user_id === userData?.user_id){
               update_obj = {
                ...total_actions[indx],
                unread_messages:iterator.unread_messages
               }
             }
          }
          // console.log('After UPdate Object >>>>>>>>>>>>>>', update_obj);
          total_actions.splice(indx, 1 , update_obj);
          setRow(total_actions);
        }
       })
    }

    return () => {
      socket.off();
    }

  },[row])


  
  const getGroups = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

      fetch(GlobalApi + "/companygroups/get_all_company_groups?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log("response of group",response);
          if (response.msg === "success") {
         setGroups(response.groups);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            getUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

   async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

    console.log("reqJson",reqJson)

    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }

    
  }


  const getPermissions = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: currentCompany?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();

            if (status) {
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("Error", error.message);
        });
    }
  };

  const fetchActions = (reset = false,_selectedPriority = undefined,_selectedStatus = undefined,_selectedUsers = undefined,_selectedAssigners = undefined,clearGroup) => {
    let _assignees = _selectedUsers == undefined ? selectedUsers : _selectedUsers;

    let selectedGroupUsers = groups.filter(item => selectedGroup.includes(item.id)).map(subItem => subItem.user_id.map(user => user.id)).flat()

if(!clearGroup){
  _assignees = [..._assignees, ...selectedGroupUsers]
}

   
    setActionLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      skip:0,
      limit:15,
      user_id: data.user_id,
      company_id: currentCompany.id,
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset ? undefined : moment(datesFilters.endDate).add(1, "d").format("YYYY-MM-DD"),
      priorities : JSON.stringify(_selectedPriority == undefined ? selectedPriority : _selectedPriority),
      statuss : JSON.stringify(_selectedStatus == undefined ? selectedStatus : _selectedStatus),
      assignees : JSON.stringify(_assignees),
      creator : JSON.stringify(_selectedAssigners == undefined ? selectedAssigners : _selectedAssigners),
    };

  //   setActionLoader(false);
  console.log(":::::::::::::::::::::::::::::::::::::", params);
  // return;

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Action/get_actions?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from get Actions >>>>>>>>>>>>", response);
        if (response.status == "Success") {
          setTotalRecords(response.total_records)
          let sortedData = response.data.sort(function(a, b) {
            return new Date(b.updatedAt) - new Date(a.updatedAt);
          });
          setRow(sortedData);
          // this.setState({ row: sortedData, selected: {} });

          setActionLoader(false);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          setActionLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchActions();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

    const fetchMoreActions = (reset = false,_selectedPriority = undefined,_selectedStatus = undefined,_selectedUsers = undefined,_selectedAssigners = undefined,clearGroup) => {
      let _assignees = _selectedUsers == undefined ? selectedUsers : _selectedUsers;

      let selectedGroupUsers = groups.filter(item => selectedGroup.includes(item.id)).map(subItem => subItem.user_id.map(user => user.id)).flat()
  
  if(!clearGroup){
    _assignees = [..._assignees, ...selectedGroupUsers]
  }

  
      let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      skip:row.length,
      limit:15,
      user_id: data.user_id,
      company_id: currentCompany.id,
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset ? undefined : moment(datesFilters.endDate).add(1, "d").format("YYYY-MM-DD"),
      priorities : JSON.stringify(_selectedPriority == undefined ? selectedPriority : _selectedPriority),
      statuss : JSON.stringify(_selectedStatus == undefined ? selectedStatus : _selectedStatus),
      assignees : JSON.stringify(_assignees),
      creator : JSON.stringify(_selectedAssigners == undefined ? selectedAssigners : _selectedAssigners),
    };

  //   setActionLoader(false);
  console.log(":::::::::::::::::::::::::::::::::::::", params);
  // return;

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Action/get_actions?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from get Actions >>>>>>>>>>>>", response);
        if (response.status == "Success") {
          setTotalRecords(response.total_records)
          let sortedData = [...row,...response.data].sort(function(a, b) {
            return new Date(b.updatedAt) - new Date(a.updatedAt);
          });
          setRow(sortedData);
    
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error == "Unexpected token"
        ) {
          setActionLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchActions();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const getUsers = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let arr = [];
          response.data.map((item) => {
            let obj = {
              first_name: item.first_name,
              last_name: item.last_name,
              id: item.id,
              checked: false,
            };
            arr.push(obj);
          });
          console.log("users??????????????????????????????????", arr);
          setAssignees(arr);
          setAssignedBy(arr);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            getUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  const handleClick1 = (event) => {
    console.log(event);
    setFilterMenu1(event.currentTarget);
  };

  const handleClick2 = (event) => {
    setFilterMenu2(event.currentTarget);
  };

  const handleClick3 = (event) => {
    setFilterMenu3(event.currentTarget);
  };

  const handleClick4 = (event) => {
    setFilterMenu4(event.currentTarget);
  };

  const handleClick5 = (event) => {
    setFilterMenu5(event.currentTarget);
  };

  const handleClick6 = async (event) => {
    setFilterMenu6(event.currentTarget);
  };

  const handleClose1 = () => {
    setFilterMenu1(null);
  };

  const handleClose2 = () => {
    setFilterMenu2(null);
  };

  const handleClose3 = () => {
    setFilterMenu3(null);
  };

  const handleClose4 = () => {
    setFilterMenu4(null);
  };

  const handleClose5 = () => {
    setFilterMenu5(null);
  };

  const handleClose6 = () => {
    setFilterMenu6(null);
  };

  const handleToday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: !datesFilters.today,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handleYesterday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: !datesFilters.yesterday,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle7Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: !datesFilters.last7,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle1Month = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: !datesFilters.lastMonth,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handleStartDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: true,
      endFlag: false,
      startDate: e.target.value,
    };
    console.log(_datesFilters);
    setDateFilters(_datesFilters);
  };

  const handleEndDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: true,
      endDate: e.target.value,
    };
    setDateFilters(_datesFilters);
  };

  const clearDatesFilter = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setFilterApplied(false);
    setDateFilters(_datesFilters);
    fetchActions(true);
  };

  const clearPriorityFilter = (type) => {
    const nextselectedPriority = selectedPriority.filter((t) => t !== type);
    setSelectedPriority(nextselectedPriority);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      fetchActions(false,nextselectedPriority,selectedStatus,selectedUsers,selectedAssigners)

    } else {
      setFilterApplied(false);
       fetchActions(true,nextselectedPriority,selectedStatus,selectedUsers,selectedAssigners)
    }
  };

  const clearStatusFilter = (type) => {
    const nextselectedStatus = selectedStatus.filter((t) => t !== type);
     setSelectedStatus(nextselectedStatus);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      fetchActions(false,selectedPriority,nextselectedStatus,selectedUsers,selectedAssigners)
    } else {
      setFilterApplied(false);
      fetchActions(true,selectedPriority,nextselectedStatus,selectedUsers,selectedAssigners)
    }
  };

  const handleDone = (type) => {
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      fetchActions(false);
    } else {
      setFilterApplied(false);
      fetchActions(true);
    }
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu6(null);

    if (type == "Assignees") {
      if (selectedUsers.length > 0 || selectedGroup.length > 0) {
        setAppliedFilters({ ...appliedFilters, Assignees: true });
      } else {
        setAppliedFilters({ ...appliedFilters, Assignees: false });
      }
    } else if (type == "Assigners") {
      if (selectedAssigners.length > 0) {
        setAppliedFilters({ ...appliedFilters, Assigners: true });
      } else {
        setAppliedFilters({ ...appliedFilters, Assigners: false });
      }
    } else if (type == "Priority") {
      if (selectedPriority.length > 0) {
        setAppliedFilters({ ...appliedFilters, Priority: true });
      } else {
        setAppliedFilters({ ...appliedFilters, Priority: false });
      }
    } else if (type == "Status") {
      if (selectedStatus.length > 0) {
        setAppliedFilters({ ...appliedFilters, Status: true });
      } else {
        setAppliedFilters({ ...appliedFilters, Status: false });
      }
    }
  };

  const handleDone2 = () => {
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      fetchActions(false);
    } else {
      setFilterApplied(false);
      fetchActions(true);
    }
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu6(null);
  };

  const clearAssigneesFilter = async () => {
    await setSelectedUsers([]);
    // document.getElementById("schedule2Scroll").scrollTo(0, 0);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      fetchActions(false,selectedPriority,selectedStatus,[],selectedAssigners)
    } else {
      setFilterApplied(false);
      fetchActions(true,selectedPriority,selectedStatus,[],selectedAssigners)
    }
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const clearGroupFilter = async () => {
    await setSelectedGroups([]);
    // document.getElementById("schedule2Scroll").scrollTo(0, 0);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      fetchActions(false,selectedPriority,selectedStatus,[],selectedAssigners,true)
    } else {
      setFilterApplied(false);
      fetchActions(true,selectedPriority,selectedStatus,[],selectedAssigners,true)
    }
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };


  const clearAssignedByFilter = () => {
    setSelectedAssigners([]);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      fetchActions(false,selectedPriority,selectedStatus,selectedUsers,[])
    } else {
      setFilterApplied(false);
      fetchActions(true,selectedPriority,selectedStatus,selectedUsers,[])
    }
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const open = Boolean(filterMenu1);
  const open2 = Boolean(filterMenu2);
  const open3 = Boolean(filterMenu3);
  const open4 = Boolean(filterMenu4);
  const open5 = Boolean(filterMenu5);
  const open6 = Boolean(filterMenu6);

  const selectUsers = (checked, item) => {
    const nextselectedUsers = checked
      ? [...selectedUsers, item.id]
      : selectedUsers.filter((t) => t !== item.id);
    setSelectedUsers(nextselectedUsers);
  };

  const selectGroups = (checked, item) => {
    const nextselectedGroup = checked
      ? [...selectedGroup, item.id]
      : selectedGroup.filter((t) => t !== item.id);
    setSelectedGroups(nextselectedGroup);
  };


  const selectAssignedBy = (checked, item) => {
    const nextselectedAssigners = checked
      ? [...selectedAssigners, item.id]
      : selectedAssigners.filter((t) => t !== item.id);
    setSelectedAssigners(nextselectedAssigners);
  };

  const selectPriority = (checked, item) => {
    const nextselectedPriority = checked
      ? [...selectedPriority, item]
      : selectedPriority.filter((t) => t !== item);
    setSelectedPriority(nextselectedPriority);
  };

  const selectStatus = (checked, item) => {
    const nextselectedStatus = checked
      ? [...selectedStatus, item]
      : selectedStatus.filter((t) => t !== item);
    setSelectedStatus(nextselectedStatus);
  };

  const handleSubmit = async (e) => {
    console.log(e);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      organization_id: data.organization_id,
    };

    // let query = Object.keys(package_inquiry)
    //   .map(
    //     (k) =>
    //       encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
    //   )
    //   .join("&");
    // let req = await fetch(GlobalApi + "/Package/action_limit?" + query, {
    //   method: "GET",
    //   headers: {
    //     Authorization: "Bearer " + token,
    //     "Content-Type": "application/json",
    //   },
    // });

    // let reqJson = await req.json();
    // if (reqJson.status === "Request is Valid") {
    //   if (e.title == "") {
    //     swal(<>{t("Warning")}</>, "Title is required", "warning");
    //     return;
    //   }

    //   fetch(GlobalApi + "/Action/create_action", {
    //     method: "post",
    //     headers: new Headers({
    //       Authorization: "Bearer " + token,
    //       "Content-Type": "application/json",
    //     }),
    //     body: JSON.stringify({
    //       ...e,
    //       created_by: data.user_id,
    //       company_id: currentCompany.id,
    //     }),
    //   })
    //     .then((response) => response.json())
    //     .then(async (res) => {
    //       console.log(res.data);
    //       if (res.status === "Success") {
    //         if (
    //           datesFilters.today == true ||
    //           datesFilters.yesterday == true ||
    //           datesFilters.last7 == true ||
    //           datesFilters.last15 == true ||
    //           datesFilters.lastMonth == true ||
    //           datesFilters.startFlag == true ||
    //           datesFilters.endFlag == true
    //         ) {
    //           setFilterApplied(true);
    //           fetchActions(false)
    //         } else {
    //           setFilterApplied(false);
    //           fetchActions(true)
    //         }
    //         setModal(false);
    //         //this.setState({ Modal: false });
    //         e.title = "";
    //         e.description = "";
    //         swal(<>{t("Success")}</>, "A new action has been added successfully.", "success");
    //       } else if (
    //         res.error === "jwt expired" ||
    //         res.error === "invalid token" ||
    //         res.error === "invalid signature" ||
    //         res.error == "Unexpected token"
    //       ) {
    //         let status = await refresh_token();
    //         console.log(status);
    //         if (status) {
    //           console.log("opopopop");
    //           handleSubmit();
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err, "error");
    //     });
    // } else {
    //   swal(<>{t("Warning")}</>, reqJson.status, "warning");
    // }
if(packageDetails?.action_limit === "Unlimited" || packageDetails?.action_limit === "yes"){
  if (e.title == "") {
    swal(t("Warning"), t("Title is required"), "warning");
    return;
  }

  fetch(GlobalApi + "/Action/create_action", {
    method: "post",
    headers: new Headers({
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({
      ...e,
      created_by: data.user_id,
      company_id: currentCompany.id,
    }),
  })
    .then((response) => response.json())
    .then(async (res) => {
      console.log(res.data);
      if (res.status === "Success") {
        if (
          datesFilters.today == true ||
          datesFilters.yesterday == true ||
          datesFilters.last7 == true ||
          datesFilters.last15 == true ||
          datesFilters.lastMonth == true ||
          datesFilters.startFlag == true ||
          datesFilters.endFlag == true
        ) {
          setFilterApplied(true);
          fetchActions(false)
        } else {
          setFilterApplied(false);
          fetchActions(true)
        }
        setModal(false);
        //this.setState({ Modal: false });
        e.title = "";
        e.description = "";
        swal(t("Success"), t("A new action has been added successfully."), "success");
      } else if (
        res.error === "jwt expired" ||
        res.error === "invalid token" ||
        res.error === "invalid signature" ||
        res.error == "Unexpected token"
      ) {
        let status = await refresh_token();
        console.log(status);
        if (status) {
          console.log("opopopop");
          handleSubmit();
        }
      }
    })
    .catch((err) => {
      console.log(err, "error");
    });
}else{
  swal(t("Warning"), packageDetails?.action_request_status, "warning");
}
    
  };

  const list =
    row.length > 0 && (
      row
        ?.filter((v) =>
          v?.title?.toLowerCase().includes(searchText?.toLowerCase())
        )
        .map((value, index) => {
          console.log("PPPPPPPPPPPPPPPPPPPPPPPPPPPPP",value)
          let userList = "";

          const isOverDue = new Date(value.due) < new Date();


          if (value.Users != null || value.Users != undefined)
            value.Users.map((item) => {
              //alert(JSON.stringify(item))
              userList =
                userList + item?.first_name + " " + item?.last_name + ",";
            });
          userList = userList.substring(0, userList.length - 1);
          //alert(userList)
          return <Grid item xs={12} sm={6} md={6} lg={3} xl={3} justifyContent="center" alignItems="flex-end">
              <Link to={`/task/${value.id}`} style={{ color: "black" }}>
                <div className="hover shadow" style={{ display: "inline-flex", justifyContent: "space-between", flexDirection: "column", border: "1px solid #dadada", padding: "10px", margin: "5px 5px 0px", flexDirection: "column", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "left", height: "200px", borderRadius: "5px", backgroundColor: "white", overflow: "hidden" }}>
                  <div style={{ width: "100%" }}>
                    {value.priority && <>
                        {value.priority == "High Priority" && <div style={{ backgroundColor: "#B00020", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                            <p
                              style={{
                                margin: "0px",
                                color: "white",
                                fontSize: "10px",
                                fontWeight: "bold",
                                textAlign: "left",
                              }}
                            >
                              {value.priority.split(" ")[0]}
                            </p>
                          </div>}

                        {value.priority == "Medium Priority" && <div style={{ backgroundColor: "#299617", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                            <p
                              style={{
                                margin: "0px",
                                color: "white",
                                fontSize: "10px",
                                fontWeight: "bold",
                                textAlign: "left",
                              }}
                            >
                              {value.priority.split(" ")[0]}
                            </p>
                          </div>}

                        {value.priority == "Low Priority" && <div style={{ backgroundColor: "#EEB609", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                            <p
                              style={{
                                margin: "0px",
                                color: "white",
                                fontSize: "10px",
                                fontWeight: "bold",
                                textAlign: "left",
                              }}
                            >
                              {value.priority.split(" ")[0]}
                            </p>
                          </div>}
                      </>}
                    <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "16px", textAlign: "left", marginBottom: "0px" }}>
                      {capitalize(value?.title.slice(0, 30) + (value?.title.length > 30 ? "..." : ""))}
                    </p>
                  </div>

                  <div style={{ width: "100%" }}>
                    {value.due && <div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <img src={due_date} width={15} height={15} />
                          &nbsp;
                          <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                            {moment(value.due).format("MM-DD-YYYY")}
                          </p>
                          &nbsp;
                          {isOverDue && <>
                              {" "}
                              <ErrorIcon style={{ color: "#B00020", fontSize: 16 }} />
                              <p className="label2" style={{ marginBottom: 0, fontSize: 10, marginTop: 2, color: "#B00020", textTransform: "capitalized" }}>
                                OverDue
                              </p>
                            </>}
                        </div>
                      </div>}
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                        {t("Active Since")} :
                      </p>
                      &nbsp;
                      <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                        {moment(value.updatedAt).fromNow()}
                      </p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                        {t("Status")} :
                      </p>
                      &nbsp;
                      <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                        {value.status ? value.status : "To Do"}
                      </p>
                    </div>
                    {value?.inspection_title && <div style={{ display: "flex", flexDirection: "row" }}>
                        <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                          {t("Inspection")} :
                        </p>
                        &nbsp;
                        <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                          {value?.inspection_title ? value?.inspection_title : "N/A"}
                        </p>
                      </div>}
                  </div>

                  <div style={{ width: "100%", display: "flex", align: "center", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                      <div style={{ paddingRight: "5px",display:'flex', flexDirection:'row' }}>
                        {(value.Users != null || value.Users != undefined) && value.Users.map(
                            (v, i) => {
                              if (i <= 2) {
                                return (
                                  <Tooltip
                                    title={`${
                                      v ? v?.first_name : ""
                                    } ${v ? v?.last_name : ""}`}
                                    aria-label=""
                                  >
                                    {v?.avatar !== null ? (
                                      <div
                                        style={{
                                          width: 30,
                                          height: 30,
                                          borderRadius: "50px",
                                          color: "#043077",
                                          display: "flex",
                                          justifyContent: "center",
                                          margin: 1,
                                          alignItems: "center",
                                          backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                            v?.avatar
                                          })`,
                                          backgroundSize: "cover",
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          width: 30,
                                          height: 30,
                                          borderRadius: "50px",
                                          border: "1px solid #043077",
                                          color: "#043077",
                                          display: "flex",
                                          justifyContent: "center",
                                          margin: 1,
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            margin: 0,
                                            fontWeight: "bold",
                                            fontSize: "10px",
                                          }}
                                        >
                                          {v
                                            ? v?.first_name
                                                .substring(0, 1)
                                                .toUpperCase()
                                                .concat(
                                                  v
                                                    ? v?.last_name
                                                        .substring(
                                                          0,
                                                          1
                                                        )
                                                        .toUpperCase()
                                                    : ""
                                                )
                                            : ""}
                                        </p>
                                      </div>
                                    )}
                                  </Tooltip>
                                );
                              }
                            }
                          )}
                        {value?.Users?.length > 3 && <div style={{ width: 30, height: 30, borderRadius: "50px", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                            <p style={{ margin: 0, fontWeight: "bold", fontSize: "10px" }}>
                              +{value?.Users?.length - 3}
                            </p>
                          </div>}
                      </div>

                      {(value.group_ids != null || value.group_ids != undefined) && value.group_ids.length > 0 && <div style={{ borderLeft:(value.Users != null || value.Users != undefined) && value.Users.length > 0 && "1px solid #043077", paddingLeft:(value.Users != null || value.Users != undefined) && value.Users.length > 0 && "5px",display:'flex', flexDirection:'row'  }}>
                          {value.group_ids.map((v, i) => {
                            if (i <= 2) {
                              return <Tooltip title={v?.group_name} aria-label="">
                                   <div style={{ width: 30, height: 30, borderRadius: "50px", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                                    <p style={{ margin: 0, fontWeight: "bold", fontSize: "10px" }}>
                                    {v?.group_name
                                      .substring(
                                        0,
                                        1
                                      )
                                        .toUpperCase()}
                                    </p>
                                  </div>
                                </Tooltip>;
                            }
                          })}
                          {value?.group_ids?.length > 2 && <div style={{ width: 30, height: 30, borderRadius: "50px", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                              <p style={{ margin: 0, fontWeight: "bold", fontSize: "10px" }}>
                                +{value?.group_ids?.length - 2}
                              </p>
                            </div>}
                        </div>}
                    </div>

                    <div style={{ paddingRight: "10px" }}>
                      <Badge badgeContent={value.unread_messages} style={{ cursor: "pointer" }} color="error">
                        <img src={chat} alt="chat" />
                      </Badge>
                    </div>
                  </div>

                  {/* <Grid container>
                  <Grid item xs={12}>
                    <Link to={`/task/${value.id}`} style={{ color: "black" }}>
                      <Grid container spacing={0} style={{ textAlign: "left" }}>
                        <Grid item xs={12} md={12}>
                          {value.priority && <>
                              {value.priority == "High Priority" && <div style={{ backgroundColor: "#B00020", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                                  <p style={{ margin: "0px", color: "white", fontSize: "10px", fontWeight: "bold", textAlign: "left" }}>
                                    {value.priority.split(" ")[0]}
                                  </p>
                                </div>}

                              {value.priority == "Medium Priority" && <div style={{ backgroundColor: "#299617", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                                  <p style={{ margin: "0px", color: "white", fontSize: "10px", fontWeight: "bold", textAlign: "left" }}>
                                    {value.priority.split(" ")[0]}
                                  </p>
                                </div>}

                              {value.priority == "Low Priority" && <div style={{ backgroundColor: "#EEB609", display: "inline-block", textAlign: "left", padding: "2px 10px", borderRadius: "20px" }}>
                                  <p style={{ margin: "0px", color: "white", fontSize: "10px", fontWeight: "bold", textAlign: "left" }}>
                                    {value.priority.split(" ")[0]}
                                  </p>
                                </div>}
                            </>}
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "16px", textAlign: "left" }}>
                            {capitalize(value.title)}
                          </p>
                        </Grid>

                        {value.due && <Grid item xs={12}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <img src={due_date} width={15} height={15} />
                              &nbsp;
                              <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                                {moment(value.due).format("MM-DD-YYYY")}
                              </p>
                            </div>
                          </Grid>}

                          <Grid item xs={12}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <Typography variant="p" style={{ marginRight: 5 }}>
                                Active since:{" "}
                              </Typography>
                              <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>
                                {moment(value.updatedAt).fromNow()}
                              </Typography>
                            </div>
                          </Grid>

                          <Grid item xs={12}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                              <Typography variant="p" style={{ marginRight: 5 }}>
                                Status:
                              </Typography>
                              <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>
                                {value.status ? value.status : "To Do"}
                              </Typography>
                            </div>
                          </Grid>

                        <Grid item xs={12} alignItems="center" justifyContent="space-between">
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                              {(value.Users != null || value.Users != undefined) && value.Users.map(
                                  (v, i) => {
                                    if (i <= 2) {
                                      return (
                                        <Tooltip
                                          title={`${
                                            v ? v?.first_name : ""
                                          } ${v ? v?.last_name : ""}`}
                                          aria-label=""
                                        >
                                          {v?.avatar !== null ? (
                                            <div
                                              style={{
                                                width: 30,
                                                height: 30,
                                                borderRadius: "50px",
                                                color: "#043077",
                                                display: "flex",
                                                justifyContent:
                                                  "center",
                                                margin: 1,
                                                alignItems: "center",
                                                backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                  v?.avatar
                                                })`,
                                                backgroundSize:
                                                  "cover",
                                              }}
                                            />
                                          ) : (
                                            <div
                                              style={{
                                                width: 30,
                                                height: 30,
                                                borderRadius: "50px",
                                                border:
                                                  "1px solid #043077",
                                                color: "#043077",
                                                display: "flex",
                                                justifyContent:
                                                  "center",
                                                margin: 1,
                                                alignItems: "center",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  margin: 0,
                                                  fontWeight: "bold",
                                                  fontSize: "10px",
                                                }}
                                              >
                                                {v
                                                  ? v?.first_name
                                                      .substring(0, 1)
                                                      .toUpperCase()
                                                      .concat(
                                                        v
                                                          ? v?.last_name
                                                              .substring(
                                                                0,
                                                                1
                                                              )
                                                              .toUpperCase()
                                                          : ""
                                                      )
                                                  : ""}
                                              </p>
                                            </div>
                                          )}
                                        </Tooltip>
                                      );
                                    } else {
                                      return (
                                        <div
                                          style={{
                                            width: 30,
                                            height: 30,
                                            borderRadius: "50px",
                                            border:
                                              "1px solid #043077",
                                            color: "#043077",
                                            display: "flex",
                                            justifyContent: "center",
                                            margin: 1,
                                            alignItems: "center",
                                          }}
                                        >
                                          <p
                                            style={{
                                              margin: 0,
                                              fontWeight: "bold",
                                              fontSize: "10px",
                                            }}
                                          >
                                            +{value.Users.length - 3}
                                          </p>
                                        </div>
                                      );
                                    }
                                  }
                                )}
                            </div>
                            <div>
                              <img src={chat} alt="chat" />
                            </div>
                          </div>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          {value.inspection_id !== null && <div style={{ display: "flex", flex: 1, flexDirection: "row", textAlign: "left", marginTop: 5 }}>
                              <Typography variant="p" style={{ marginRight: 5 }}>
                                Inspection:
                              </Typography>
                              <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>
                                {value.Inspection?.Schedule?.title}
                              </Typography>
                            </div>}
                        </Grid>
                      </Grid>
                    </Link>
                  </Grid>
                </Grid> */}
                </div>
              </Link>
            </Grid>;
        })
    );


     const handleScroll = (e) => {
  let currentRecords = row.length;
 
  const bottom = e.target.scrollHeight - Math.ceil(e.target.scrollTop) === e.target.clientHeight;

  if (bottom) {
    if(currentRecords < totalRecords){
      if(filterApplied){
        fetchMoreActions(false);
      }else{
        fetchMoreActions(true);
      }
      
    }
   
  }
};



  const ModalOpen = () => {
    setModal(true);
  };

  if (localStorage.getItem("UserData") === null) {
    return <Redirect to={"/signin"} />;
  }
  var retrievedData = localStorage.getItem("UserData");
  var data = JSON.parse(retrievedData);
  if (data.token == null) {
    return <Redirect to={"/signin"} />;
  } else {
    return <>
        <MiddleHeader /> <div style={{ overflowY: "auto", overflowX: "hidden", backgroundColor: Colors.globalColor9, width: "100%", padding: "20px" }}>
          <Grid className="shadow" container justifyContent="flex-start" alignItems="flex-start" style={{ backgroundColor: "white",
              borderRadius: "5px", padding: "0px", overflow: "hidden" }}>
            <Grid item xs={12} style={{ borderBottom: "1px solid #dadada" }}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ backgroundColor: "white", borderRadius: "5px", padding: "10px 20px 0px", display: "flex", justifyContent: "space-between" }}>
                <Grid item xs={12} md={4}>
                <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "5px", marginTop: "5px" }}>
                <p className="label2" style={{ display: "inline", marginTop: 0, fontSize: 16, color: Colors.globalColor8, textTransform: "uppercase" }}>
                  {t("Actions")}
                </p>
              </div>
                </Grid>

                <Grid item xs={12} md={6}>
                </Grid>

                <Grid align="right" xs={12} md={2} style={{ alignSelf: "center" }}>
                {userData?.super_admin == true ||
                                  permissions_obj["Admin"] == true ||
                                  permissions_obj[
                                    "Action"
                                  ] == true ?
                                  <Button variant="contained" type="submit" className="addBtn" component="span" style={{ width: "100%", margin: 0, backgroundColor: Colors.globalColor8 }} onClick={() => ModalOpen()}>
                                  {t("Create Action")}
                                </Button> :  <Button variant="contained" type="submit" className="ctBtn2" component="span" style={{ width: "100%", margin: 0, backgroundColor: Colors.globalColor8 }} disabled>
                    {t("Create Action")}
                  </Button>}

                  
                </Grid>
              </Grid>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ backgroundColor: "white", borderRadius: "5px", padding: "5px 20px 10px", display: "flex", justifyContent: "space-between" }}>
                <Grid item xs={12} md={4}>
                  <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                          <img src={search} width={12} />
                        </InputAdornment>, endAdornment: <InputAdornment position="end">
                          <Tooltip title={t("Filter Options")}>
                            <img src={filter} width={20} style={{ cursor: "pointer" }} onClick={handleClick1} />
                          </Tooltip>
                        </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search in existing actions")} fullWidth onChange={(e) => setSearchText(e.target.value)} variant="outlined" style={{ width: "100%", backgroundColor: Colors.globalColor5 }} />

                  {/* =================================popover 1=========================== */}

                  <Popover open={open} anchorEl={filterMenu1} onClose={handleClose1} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }}>
                    <div style={{ width: "150px", backgroundColor: "white", borderRadius: "5px", padding: "0px" }}>
                      <List component="nav" aria-label="secondary mailbox folders">
                        <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick2(e)}>
                        <ListItemText primary={t("Assignee/Groups")} />
                        </ListItem>
                        <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick3(e)}>
                          <ListItemText primary={t("Assigned by")} />
                        </ListItem>

                        <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick4(e)}>
                          <ListItemText primary={t("Priority")} />
                        </ListItem>

                        <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick5(e)}>
                          <ListItemText primary={t("Status")} />
                        </ListItem>
                        <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick6(e)}>
                          <ListItemText primary={t("Dates")} />
                        </ListItem>
                      </List>
                    </div>
                  </Popover>

                  {/* =================================popover 2=========================== */}
                  <Popover open={open2} anchorEl={filterMenu2} onClose={handleClose2} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
                    <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                      <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                              <img src={search} width={12} />
                            </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={userFilter} onChange={(e) => setUserFilter(e.target.value)} />

                      <br />
                      <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                        {t("Assignees")}
                      </p>
                      <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                        {Assignees.filter((word) => word.first_name
                              .toLowerCase()
                              .includes(
                                userFilter.toLowerCase()
                              ) || word.last_name
                              .toLowerCase()
                              .includes(
                                userFilter.toLowerCase()
                              ) || (word.first_name + " " + word.last_name)
                              .toLowerCase()
                              .includes(
                                userFilter.toLowerCase()
                              )).map((item, index) => {
                          return <span style={{ display: "block" }}>
                              <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectUsers(e.target.checked, item)} defaultChecked={selectedUsers.indexOf(item.id) > -1} />
                              <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                                {item.first_name}
                              </p>
                              &nbsp;
                              <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                                {item.last_name}
                              </p>
                            </span>;
                        })}
                      </div>

                      <p
                    className="label2"
                    style={{
                      marginTop: "10px",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {t("Groups")}
                  </p>
                  <div
                    className="scrollbarShow2"
                    style={{ maxHeight: "100px", overflowY: "scroll" }}
                  >
                    {groups.filter(
                      (word) =>
                        word.group_name
                          .toLowerCase()
                          .includes(userFilter.toLowerCase()) 
                    ).map((item, index) => {
                      return (
                        <span style={{ display: "block" }}>
                          <Checkbox
                            className="filterCheckbox"
                            style={{ color: Colors.globalColor8 }}
                            onChange={(e) =>
                              selectGroups(e.target.checked, item)
                            }
                            defaultChecked={selectedGroup.indexOf(item.id) > -1}
                          />
                          <p
                            className="label2"
                            style={{
                              display: "inline",
                              marginTop: "0px",
                              fontSize: 12,
                              textTransform: "capitalize",
                              fontWeight: "normal",
                            }}
                          >
                            {item.group_name}
                          </p>
                       
                        </span>
                      );
                    })}
                  </div>

                      <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                      <Button className="ctBtn" onClick={() => handleDone("Assignees")}>
                        {t("Done")}
                      </Button>
                    </div>
                  </Popover>

                  {/* =================================popover 3=========================== */}
                  <Popover open={open3} anchorEl={filterMenu3} onClose={handleClose3} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
                    <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                      <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                              <img src={search} width={12} />
                            </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={assignedByFilter} onChange={(e) => setAssignedByFilter(e.target.value)} />

                      <br />
                      <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                        {t("Assigned by")}
                      </p>
                      <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                        {AssigneBy.filter((word) => word.first_name
                              .toLowerCase()
                              .includes(
                                assignedByFilter.toLowerCase()
                              ) || word.last_name
                              .toLowerCase()
                              .includes(
                                assignedByFilter.toLowerCase()
                              ) || (word.first_name + " " + word.last_name)
                              .toLowerCase()
                              .includes(
                                assignedByFilter.toLowerCase()
                              )).map((item, index) => {
                          return <span style={{ display: "block" }}>
                              <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectAssignedBy(e.target.checked, item)} defaultChecked={selectedAssigners.indexOf(item.id) > -1} />
                              <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                                {item.first_name}
                              </p>
                              &nbsp;
                              <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                                {item.last_name}
                              </p>
                            </span>;
                        })}
                      </div>

                      <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                      <Button className="ctBtn" onClick={() => handleDone("Assigners")}>
                        {t("Done")}
                      </Button>
                    </div>
                  </Popover>

                  {/* =================================popover 4=========================== */}
                  <Popover open={open4} anchorEl={filterMenu4} onClose={handleClose4} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
                    <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                      <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                        {t("Priority")}
                      </p>

                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" defaultChecked={selectedPriority.indexOf("High Priority") > -1} style={{ color: Colors.globalColor8 }} onChange={(e) => selectPriority(e.target.checked, "High Priority")} />
                        {t("High Priority")}
                      </span>
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" defaultChecked={selectedPriority.indexOf("Medium Priority") > -1} style={{ color: Colors.globalColor8 }} onChange={(e) => selectPriority(e.target.checked, "Medium Priority")} />
                        {t("Medium Priority")}
                      </span>
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" defaultChecked={selectedPriority.indexOf("Low Priority") > -1} style={{ color: Colors.globalColor8 }} onChange={(e) => selectPriority(e.target.checked, "Low Priority")} />
                        {t("Low Priority")}
                      </span>

                      <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                      <Button className="ctBtn" onClick={() => handleDone("Priority")}>
                        {t("Done")}
                      </Button>
                    </div>
                  </Popover>

                  {/* =================================popover 5=========================== */}
                  <Popover open={open5} anchorEl={filterMenu5} onClose={handleClose5} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
                    <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                      <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                        {t("Status")}
                      </p>

                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" defaultChecked={selectedStatus.indexOf("To Do") > -1} style={{ color: Colors.globalColor8 }} onChange={(e) => selectStatus(e.target.checked, "To Do")} />
                        {t("To Do")}
                      </span>
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" defaultChecked={selectedStatus.indexOf("In Progress") > -1} style={{ color: Colors.globalColor8 }} onChange={(e) => selectStatus(e.target.checked, "In Progress")} />
                        {t("In Progress")}
                      </span>
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" defaultChecked={selectedStatus.indexOf("Complete") > -1} style={{ color: Colors.globalColor8 }} onChange={(e) => selectStatus(e.target.checked, "Complete")} />
                        {t("Complete")}
                      </span>

                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" defaultChecked={selectedStatus.indexOf("Can't Do") > -1} style={{ color: Colors.globalColor8 }} onChange={(e) => selectStatus(e.target.checked, "Can't Do")} />
                        {t("Can't Do")}
                      </span>

                      <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                      <Button className="ctBtn" onClick={() => handleDone("Status")}>
                        {t("Done")}
                      </Button>
                    </div>
                  </Popover>

                  {/* =================================popover 6=========================== */}
                  <Popover open={open6} anchorEl={filterMenu6} onClose={handleClose6} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
                    <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                      <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                        {t("Select Date Range")}
                      </p>
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.today} onChange={() => handleToday()} />
                        <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                          {t("Today")}
                        </p>
                      </span>
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.yesterday} onChange={() => handleYesterday()} />
                        <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                          {t("Yesterday")}
                        </p>
                      </span>
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last7} onChange={() => handle7Days()} />
                        <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                          {t("Last 7 Days")}
                        </p>
                      </span>
                      {/* <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last15} onChange={()=>handle15Days()} />
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    Last 15 Days
                  </p>
                </span> */}
                      <span style={{ display: "block" }}>
                        <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.lastMonth} onChange={() => handle1Month()} />
                        <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                          {t("Last Month")}
                        </p>
                      </span>
                      <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                        {t("Custom Range")}
                      </p>

                      {/* <KeyboardDatePicker className="filterDatePicker" disableToolbar label="From Date"  format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.startDate} onChange={handleStartDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                      {/* <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 0, width: "100%", marginBottom: 10 }} /> */}
                      <form className={classes.container} noValidate>
                        <TextField variant="outlined" className="filterDatePicker" label={t("From Date")} type="date" size="small" fullwidth value={datesFilters.startDate} onChange={handleStartDate}  style={{ width: "100%", marginTop: "10px" }} InputLabelProps={{ shrink: true }} />
                        <TextField variant="outlined" className="filterDatePicker" label={t("To Date")} type="date" size="small" fullwidth value={datesFilters.endDate} onChange={handleEndDate}  style={{ width: "100%", marginTop: "10px" }} InputLabelProps={{ shrink: true }} />
                        {/* <KeyboardDatePicker className="filterDatePicker" style={{ marginTop: "10px", marginBottom: "10px" }} disableToolbar label="To Date" variant="outlined" format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.endDate} onChange={handleEndDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                      </form>
                      <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                      <Button className="ctBtn" onClick={() => handleDone2()}>
                        {/* onClick={() => onselectPriority()} */}
                        {t("Done")}
                      </Button>
                    </div>
                  </Popover>
                </Grid>

                <Grid item xs={12} md={6}>
                  <div className="scrollHidden2" style={{ overflow: "auto", whiteSpace: "nowrap", display: "flex", maxWidth: "700px", paddingBottom: "5px" }}>
                  &nbsp;
                    {filterApplied && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                            {datesFilters.today && "Today"}
                            {datesFilters.yesterday && "Yesterday"}
                            {!datesFilters.today && !datesFilters.yesterday && `From : ${moment(datesFilters.startDate).format("DD-MM-YY")} - To: ${moment(datesFilters.endDate).format("DD-MM-YY")}`}
                          </div>
                          <div onClick={() => clearDatesFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedUsers.length > 0 && appliedFilters.Assignees && <div style={{ backgroundColor: Colors.globalColor9, justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                            {Assignees.filter((v) => v?.id == selectedUsers[0])[0].first_name} {selectedUsers.length > 1 && <>
                                {" "}
                                +{selectedUsers.length - 1}{" "}
                              </>}
                            {/* Filter Assignees +{selectedUsers.length} */}
                          </div> <div onClick={() => clearAssigneesFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedGroup.length > 0 && appliedFilters.Assignees && <div style={{ backgroundColor: Colors.globalColor9, justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                            {groups.filter((v) => v?.id == selectedGroup[0])[0].group_name} {selectedGroup.length > 1 && <>
                                {" "}
                                +{selectedGroup.length - 1}{" "}
                              </>}
                            {/* Filter Assignees +{selectedUsers.length} */}
                          </div> <div onClick={() => clearGroupFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedAssigners.length > 0 && appliedFilters.Assigners && <div style={{ backgroundColor: Colors.globalColor9, justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                            {AssigneBy.filter((v) => v?.id == selectedAssigners[0])[0].first_name} {selectedAssigners.length > 1 && <>
                                {" "}
                                +{selectedAssigners.length - 1}{" "}
                              </>}
                            {/* Filter AssignedBy +{selectedAssigners.length} */}
                          </div> <div onClick={() => clearAssignedByFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedPriority.length > 0 && appliedFilters.Priority && selectedPriority.includes("High Priority") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                            {t("High Priority")}
                          </div> <div onClick={() => clearPriorityFilter("High Priority")} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedPriority.length > 0 && appliedFilters.Priority && selectedPriority.includes("Medium Priority") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                            {t("Medium Priority")}
                          </div> <div onClick={() => clearPriorityFilter("Medium Priority")} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedPriority.length > 0 && appliedFilters.Priority && selectedPriority.includes("Low Priority") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                            {t("Low Priority")}
                          </div> <div onClick={() => clearPriorityFilter("Low Priority")} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedStatus.length > 0 && appliedFilters.Status && selectedStatus.includes("To Do") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                            {t("To Do")}
                          </div> <div onClick={() => clearStatusFilter("To Do")} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedStatus.length > 0 && appliedFilters.Status && selectedStatus.includes("In Progress") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                            {t("In Progress")}
                          </div> <div onClick={() => clearStatusFilter("In Progress")} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedStatus.length > 0 && appliedFilters.Status && selectedStatus.includes("Complete") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                            {t("Complete")}
                          </div> <div onClick={() => clearStatusFilter("Complete")} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                    &nbsp;
                    {selectedStatus.length > 0 && appliedFilters.Status && selectedStatus.includes("Can't Do") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                        <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                          <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                            {t("Can't Do")}
                          </div> <div onClick={() => clearStatusFilter("Can't Do")} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                            x
                          </div>
                        </div>
                      </div>}
                  </div>
                </Grid>

                <Grid item xs={12} lg={2} style={{ textAlign:window.innerWidth > 700 ? (language == "ar" ? "left" :"right") : "center"}}>
                    {searchText == "" && <p className="label2" style={{ textAlign:window.innerWidth > 700 ? (language == "ar" ? "left" :"right") : "center",display: "inline", marginTop: 8, fontSize: 12, color: "grey", textTransform: "capitalized" }}>
                        {t("showing records")} {row.length} {t("of")} {totalRecords}
                      </p>}
                  </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: "10px" }}>
              <div style={{ overflow: "hidden", padding: "0px 0px 10px", width: "100%" }}>
                {actionLoader && <div style={{padding:'20px'}}><Spinner /></div>}
                {!actionLoader && <><Grid container justifyContent="center" spacing={2} style={{ padding: "0px 10px 10px", width: "100%", height: "58vh", overflowY: "scroll" }} className="scrollbarShow2" onScroll={(e) => handleScroll(e)}>
                {row.length !== 0 ? list : <div style={{ padding: "20px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
                        <NoRecords />
                      </div>} 
                  </Grid></>}
              </div>
            </Grid>
          </Grid>

          <AddAction onClose={() => setModal(false)} handleSubmit={handleSubmit} open={modal} />
        </div>
      </>;
  }
}

export default Action;

// class training extends Component {
//   state = {
//     Modal: false,
//   };
//   state = {
//     row: null,
//     searchText: "",
//   };

//   componentDidMount() {
//     this.props.showside();

//     this.fetchActions();
//   }

//   fetchActions = () => {
//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;
//     let params = {
//       user_id: data.user_id,
//     };

//     let query = Object.keys(params)
//       .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
//       .join("&");

//     fetch(GlobalApi + "/Action/get_actions?" + query, {
//       method: "GET",
//       headers: {
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       },
//     })
//       .then((responseJson) => responseJson.json())
//       .then(async (response) => {
//         console.log(response);
//         if (response.status == "Success") {

//           let sortedData = response.data.sort(function (a, b) {
//             return new Date(b.updatedAt) - new Date(a.updatedAt)
//           })
//           this.setState({ row: sortedData, selected: {} });
//           //alert(JSON.stringify(sortedData))

//         } else if (
//           response.error === "jwt expired" ||
//           response.error === "invalid token" ||
//           response.error === "invalid signature" ||
//           response.error == "Unexpected token"
//         ) {
//           let status = await refresh_token();
//           console.log(status);
//           if (status) {
//             console.log("opopopop");
//             this.fetchActions();
//           }
//         }
//       })
//       .catch((error) => console.log(error.message));
//   };

//   handleSubmit = async (e) => {

//     console.log(e);

//     let localstorage = localStorage.getItem("UserData");
//     var data = JSON.parse(localstorage);
//     let token = data.token;
//     let package_inquiry = {
//       organization_id: data.organization_id,
//     };

//     let query = Object.keys(package_inquiry)
//       .map(
//         (k) =>
//           encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
//       )
//       .join("&");
//     let req = await fetch(GlobalApi + "/Package/action_limit?" + query, {
//       method: "GET",
//       headers: {
//         Authorization: "Bearer " + token,
//         "Content-Type": "application/json",
//       },
//     });

//     let reqJson = await req.json();
//     if (reqJson.status === "Request is Valid") {
//       if (e.title == "") {
//         swal(<>{t("Warning")}</>, "Title is required", "warning");
//         return;
//       }

//       fetch(GlobalApi + "/Action/create_action", {
//         method: "post",
//         headers: new Headers({
//           Authorization: "Bearer " + token,
//           "Content-Type": "application/json",
//         }),
//         body: JSON.stringify({
//           ...e,
//           created_by: data.user_id,
//           organization_id: data.organization_id,
//         }),
//       })
//         .then((response) => response.json())
//         .then(async (res) => {
//           console.log(res.data);
//           if (res.status === "Success") {
//             this.fetchActions();
//             this.setState({ Modal: false });
//             e.title = ""
//             e.description = ""
//             swal(<>{t("Success")}</>, "Action Added.", "success");
//           } else if (
//             res.error === "jwt expired" ||
//             res.error === "invalid token" ||
//             res.error === "invalid signature" ||
//             res.error == "Unexpected token"
//           ) {
//             let status = await refresh_token();
//             console.log(status);
//             if (status) {
//               console.log("opopopop");
//               this.handleSubmit();
//             }
//           }
//         })
//         .catch((err) => {
//           console.log(err, "error");
//         });
//     } else {
//       swal(<>{t("Warning")}</>, reqJson.status, "warning");
//     }
//   };

//   render() {
//     const list =
//       this.state.row?.length !== 0 ? (
//         this.state.row?.filter((v) =>
//           v?.title
//             ?.toLowerCase()
//             .includes(this.state.searchText?.toLowerCase())
//         )
//           .map((value, index) => {
//             let userList = ""
//             if (value.Users != null || value.Users != undefined)
//               value.Users.map(item => {
//                 //alert(JSON.stringify(item))
//                 userList = userList + item?.first_name + " " + item?.last_name + ","
//               })
//             userList = userList.substring(0, userList.length - 1)
//             //alert(userList)
//             return (
//               <Paper
//                 variant="outlined"
//                 style={{ padding: 10, marginBottom: 5 }}
//                 className="new-hover "
//               >
//                 <Grid container>
//                   <Grid item xs={12}>
//                     <Link to={`/task/${value.id}`} style={{ color: "black" }}>
//                       <Grid container>
//                         <Grid item xs={12} md={12}>
//                           <Typography variant="h6" style={{ color: Colors.globalColor8 }}>
//                             {capitalize(value.title)}
//                           </Typography>
//                         </Grid>
//                         <Grid item xs={12} md={3}>
//                           <div style={{ display: "flex", flexDirection: "row" }}>
//                             <Typography variant="p" style={{ marginRight: 5 }}>Priority: </Typography>
//                             <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}> {value.priority ? value.priority : "Not given"} </Typography>

//                           </div>
//                         </Grid>
//                         <Grid item xs={12} md={3}>
//                           <div style={{ display: "flex", flexDirection: "row" }}>
//                             <Typography variant="p" style={{ marginRight: 5 }}>Due Date: </Typography>
//                             <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>
//                               {" "}
//                               {value.due
//                                 ? moment(value.due).format("MM-DD-YYYY")
//                                 : "Not set yet"}
//                             </Typography>
//                           </div>
//                         </Grid>
//                         <Grid item xs={12} md={3}>
//                           <div style={{ display: "flex", flexDirection: "row" }}>
//                             <Typography variant="p" style={{ marginRight: 5 }}>Assigned To:</Typography>
//                             <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>

//                               {userList ? userList : "Nobody"}
//                             </Typography>
//                           </div>
//                         </Grid>
//                         {/* <Grid item xs={12} md={3}>
//                     <Typography variant="p">Created By: {value.by}</Typography>
//                   </Grid> */}

//                         <Grid item xs={12} md={12}>

//                           {value.inspection_id !== null && (
//                             <div
//                               style={{
//                                 display: "flex",
//                                 flex: 1,
//                                 flexDirection: "row",
//                                 textAlign: "left",
//                                 marginTop: 5,
//                               }}
//                             >
//                               <Typography variant="p" style={{ marginRight: 5 }}>Inspection:</Typography>
//                               <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>
//                                 {value.Inspection?.Schedule?.title}
//                               </Typography>
//                             </div>
//                           )}

//                         </Grid>
//                         {/* <Grid container>
//                           <Grid item>
//                             <Typography variant="p">
//                               Active since: {moment(value.updatedAt).fromNow()}
//                             </Typography>{" "}
//                             <Typography variant="p">
//                               Status: {value.status ? value.status : "To Do"}
//                             </Typography>
//                           </Grid>
//                         </Grid> */}
//                         <Grid item xs={12} md={3}>
//                           <div style={{ display: "flex", flexDirection: "row" }}>
//                             <Typography variant="p" style={{ marginRight: 5 }}>Active since: </Typography>
//                             <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>
//                               {moment(value.updatedAt).fromNow()}
//                             </Typography>
//                           </div>
//                         </Grid>
//                         <Grid item xs={12} md={3}>
//                           <div style={{ display: "flex", flexDirection: "row" }}>
//                             <Typography variant="p" style={{ marginRight: 5 }}>Status:</Typography>
//                             <Typography style={{ color: Colors.globalColor8, marginTop: -2 }}>
//                               {value.status ? value.status : "To Do"}
//                             </Typography>
//                           </div>
//                         </Grid>

//                       </Grid>
//                     </Link>
//                   </Grid>
//                 </Grid>
//               </Paper>
//             );
//           })
//       ) : (
//         <NoRecords />
//       );

//     const ModalOpen = () => {
//       this.setState({ Modal: true });
//     };

//     if (localStorage.getItem("UserData") === null) {
//       return <Redirect to={"/signin"} />;
//     }
//     var retrievedData = localStorage.getItem("UserData");
//     var data = JSON.parse(retrievedData);
//     if (data.token == null) {
//       return <Redirect to={"/signin"} />;
//     }
//     // if (this.state.row === null) {
//     //   return <Spinner />;
//     // }
//     else {
//       return (
//         <Container style={{ backgroundColor: 'green' }}>
//           <br />
//           {/* <Typography variant="h4" style={{ color: Colors.globalColor8 }}>
//             Actions
//           </Typography> */}
//           <Grid container direction="row">

//             <Grid item xs={12} sm={12} md={10} >
//               <TextField
//                 id="outlined-basic"
//                 label={t("Search")}
//                 autoComplete="off"
//                 fullWidth
//                 onChange={(e) =>
//                   this.setState({ searchText: e.target.value })
//                 }
//                 variant="outlined"
//               />

//             </Grid>
//             <Grid md={2} align="right" style={{ alignSelf: "center" }}>
//               <DarkButton style={{ margin: 5 }} onClick={() => ModalOpen()}>
//                 Create Action
//               </DarkButton>
//             </Grid>
//           </Grid>
//           <br />
//           {list}

//           <AddAction
//             onClose={() => this.setState({ Modal: false })}
//             handleSubmit={this.handleSubmit}
//             open={this.state.Modal}
//           />
//         </Container>
//       );
//     }
//   }
// }
// export default training;
